import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { supabase } from '../supabase/client'

const VerifyOtpPage = () => {
  const [otpCode, setOtpCode] = useState('')
  const [alertMessage, setAlertMessage] = useState('')
  const [alertType, setAlertType] = useState('')
  const location = useLocation()
  const navigate = useNavigate()
  const email = location.state?.email || ''

  useEffect(() => {
    if (!email) {
      setAlertMessage('Электронная почта не найдена. Перенаправление на страницу входа.')
      setAlertType('error')
      setTimeout(() => navigate('/login'), 2000)
    }
  }, [email, navigate])

  const handleVerifyOtp = async () => {
    if (!otpCode) {
      setAlertMessage('Пожалуйста, введите код')
      setAlertType('error')
      return
    }
    const { data, error } = await supabase.auth.verifyOtp({ email, token: otpCode, type: 'email' })
    if (error) {
      setAlertMessage('Ошибка подтверждения кода из Email: ' + error.message)
      setAlertType('error')
    } else if (data.user) {
      setAlertMessage('Вход успешен!')
      setAlertType('success')
      navigate('/dashboard') // Active redirect after success
    }
  }

  return (
    <div className="container">
      <h2>Подтверждение кода из Email</h2>
      {alertMessage && (
        <div
          style={{
            backgroundColor: alertType === 'error' ? 'pink' : 'lightgreen',
            padding: '10px',
            marginBottom: '10px',
            border: '1px solid',
            borderRadius: '4px',
          }}
        >
          {alertMessage}
          <button onClick={() => setAlertMessage('')} style={{ marginLeft: '10px' }}>
            X
          </button>
        </div>
      )}
      <div className="form-group">
        <input
          type="text"
          value={otpCode}
          onChange={(e) => setOtpCode(e.target.value)}
          placeholder="Введите код из Email"
        />
        <button onClick={handleVerifyOtp} className="btn">
          Подтвердить код из Email
        </button>
      </div>
    </div>
  )
}

export default VerifyOtpPage
